import { render, staticRenderFns } from "./OurTradeDetails.vue?vue&type=template&id=1b09e732&"
import script from "./OurTradeDetails.vue?vue&type=script&lang=js&"
export * from "./OurTradeDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports